/**
 * FILE-OVERVIEW:
 * - 役割: 共通ローディング表示コンポーネント。
 * - 主な連携: App.js, 各非同期画面
 * - 本番運用上の注意: 表示条件の競合でスピナー出しっぱなしにならないよう注意。
 */

import React from 'react';
import { Box, Typography } from '@mui/material';

const LoadingSpinner = (): React.ReactElement => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <Typography>読み込み中...</Typography>
    </Box>
  );
};

export default LoadingSpinner;